import { useState } from "react";
import { Reveal, SectionTag, SectionTitle } from "./shared";
import { NIA_TRANSPORT } from "../data/site";
import { MobilityHubMap } from "./MobilityHubMap";
import { MobilityModeCard } from "./MobilityModeCard";
import { TravelTimeEstimator } from "./TravelTimeEstimator";

export function AirportMobility() {
  const [active, setActive] = useState(NIA_TRANSPORT[0].id);

  return (
    <section id="airport-mobility" className="relative py-28 lg:py-40 bg-[#0D0D0D] overflow-hidden" data-testid="airport-mobility-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>Getting to the Airport</SectionTag>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 items-end mb-12">
          <SectionTitle>
            Seven Ways to Reach NIA.<br />
            <span className="text-gold-gradient italic">All Converging Near GYC.</span>
          </SectionTitle>
          <Reveal delay={0.15}>
            <p className="text-sm sm:text-base text-[#A1A1AA] leading-relaxed max-w-lg">
              Metro, Namo Bharat rapid rail, pod taxis, mainline rail, a bullet-train station, an
              inter-state bus terminal and three new expressways are all planned or under way around
              Noida International Airport. Select a mode to trace its route on the map.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <MobilityHubMap active={active} onSelect={setActive} />
        </Reveal>

        <Reveal delay={0.1} className="mt-6">
          <TravelTimeEstimator onSelectMode={setActive} />
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 mt-10" data-testid="mobility-mode-grid">
          {NIA_TRANSPORT.map((m, i) => (
            <MobilityModeCard key={m.id} mode={m} active={active === m.id} onSelect={() => setActive(m.id)} delay={0.05 + (i % 4) * 0.07} />
          ))}
        </div>

        <p className="mt-10 text-[11px] text-[#52525b] leading-relaxed max-w-4xl" data-testid="mobility-disclaimer">
          Routes are schematic, not to scale. Project status, alignment, station lists, costs and
          timelines are compiled from public reporting (NCRTC, NHSRCL, NHAI, YEIDA, NMRC and press
          coverage) as of research date and change frequently - none of these projects should be
          treated as committed until formally sanctioned and under construction. Verify with the
          respective authority before making any decision.
        </p>
      </div>
    </section>
  );
}
